module.exports = __webpack_public_path__ + "cc460f354c4f5d799937a3e0ab14ea4f.pdf";